import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { AlertComponent } from '../../../structure/alert/alert.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ComplianceMasterService } from '../../../services/compliance-master.service'
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Rx';
import * as _ from 'lodash';

declare var $: any;
var moment = require('moment');

@Component({
  selector: 'app-compliance-certificate-list',
  templateUrl: './compliance-certificate-list.component.html',
  styleUrls: ['./compliance-certificate-list.component.css']
})
export class ComplianceCertificateListComponent implements OnInit {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();
  complianceCertificateData: any[];
  complianceCertificateId: any;
  dataAvailable: boolean;
  searchParam: any = {};
  periodicityData: any[];
  checkAllAgenda: boolean = false;

  constructor(
    private ComplianceMasterService: ComplianceMasterService,private activatedRoute: ActivatedRoute,
    private router: Router,
    private alert: AlertComponent
  ) { }

  ngOnInit() {
    this.getComplianceCertificate();
    this.getPeriodictyData();
    var self = this;
    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [1, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      // columnDefs: [{ orderable: false, targets: [1] }],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [{
        text: '<i class="fa fa-files-o"></i> Export to Excel',
        className: 'btn btn-sm btn-warning export-btn',
        filename: 'Compliance Certificate List',
        title: 'Compliance Certificate List',
        extend: 'excel',
        exportOptions: {
          columns: [1, 2, 3],
          format: {
            body: function ( data, row, column, node ) {
                if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                  if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                }else{ return data }
              }
          }
        }
      }, {
        text: '<em class="fa fa-check"></em>Activate',
        className: 'btn btn-sm btn-primary',
        action: function (e, dt, node, config) {
          self.activateCertificates()
        }
      }]
    };

  }
  hello() {
    console.log("hello")
  }
addComplianceCertificate(){
this.router.navigate(
      [{ outlets: { 'structure-outlet': ['complianceCertificate','add']  } }],
      { relativeTo: this.activatedRoute.parent });
}
  activateCertificates() {
    let filteredData = this.complianceCertificateData.filter(function (ele) {
      return ele.IsSelected == true
    })
    if (filteredData.length > 0) {
      this.ComplianceMasterService.activateMultipleCertificates(filteredData)
        .subscribe(dataList => {
          if (dataList.status == 0) {
            this.getComplianceCertificate()
            this.alert.success("Compliance certificates activated successfully")
          } else {
            this.getComplianceCertificate()
            this.alert.error("Oops, something went wrong")
          }
        })
    } else {
      this.alert.error("Please select certificate/s to activate")
    }

  }
  getComplianceCertificate() {
    this.ComplianceMasterService.getComplianceCertificate(this.searchParam)
      .subscribe(dataList => {
        if (dataList.status == 0) {
    // $("#compliance").DataTable().destroy();
          this.complianceCertificateData = [];
          this.dataAvailable = true;
          this.complianceCertificateData = dataList.data;
          this.dtTrigger.next();
        } else {
          this.complianceCertificateData = [];
          this.dataAvailable = false;
          this.dtTrigger.next();
        }
      })
  }

  editComplianceCertificate(id) {
     this.router.navigate(
      [{ outlets: { 'structure-outlet': ['complianceCertificate','edit',id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['complianceCertificate/edit/', id]);
  }

  deleteConfirmation(id) {
    this.complianceCertificateId = id;
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#confirmation').removeClass('show').hide();

    setTimeout(() => {
      $('#confirmation').modal('show');
    }, 100);
  }

  deleteComplianceCertificate() {
    console.log("id is here:"+this.complianceCertificateId)
    if (this.complianceCertificateId != undefined && this.complianceCertificateId != "") {
      this.ComplianceMasterService.deleteComplianceCertificate(this.complianceCertificateId).subscribe(data => {
        if (data.status == 0) {
          $('#deleteMeetingConfirmation').modal('hide');
          this.alert.successWithOk1(data.message,()=>{
            $('#confirmation').off('hidden.bs.modal');   
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
          });
        }
        if (this.dtElement.dtInstance != undefined) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
          });
        }
        this.getComplianceCertificate()
      });
    }
  }

  getPeriodictyData() {
    this.periodicityData = [];
    this.ComplianceMasterService.getPeriodicityData()
      .subscribe((response:any) => {
        if (response.status == 0) {
          this.periodicityData = response.data;
        }
      })
  }

  clear() {
    this.searchParam = {}
  }

  selectAllAgenda(event) {
    console.log(event)
    this.complianceCertificateData.forEach(element => {
      if (event == true) {
        element.IsSelected = true;
      } else {
        element.IsSelected = false;
      }
    });
  }
  selectSingleAgenda(event, id) {
    console.log(event, id)

    this.complianceCertificateData.forEach(element => {
      if (element._id == id) {
        if (event == true) {
          element.IsSelected = true;
        } else {
          element.IsSelected = false;
        }
      }
    })
  }

}
